import { z } from 'zod';
/**
 * A6 (Order IAZI-FORMULARE-HEDO 8.10.): the PARAMETER DOSSIER of one model call
 * — what we sent (path, query, body; object data only, never contact or person
 * data) and IAZI's answer through a WHITE LIST: `executionInfo`, the result
 * figures, `dataInfo` and `parameterInfo`. Matteo (8.10.) sees how often we
 * call, not what; this is what we hand him. Persisted per ValuationRequest as
 * `avmModelPath` / `avmRequest` / `avmResponse`.
 *
 * Bounds are ours: every string at most {@link DOSSIER_TEXT_MAX} characters,
 * at most {@link DOSSIER_PARAMETER_MAX} parameter rows. `replacedValue` and
 * `rateComponentInfo` stay out (bouwspec Z14: only with the owner's consent).
 */
export const DOSSIER_TEXT_MAX = 2000;
export const DOSSIER_PARAMETER_MAX = 100;
const text = z.string().max(DOSSIER_TEXT_MAX);
const zahlOderText = z.union([z.number(), text]);
/** `/models/v4/ppch/cv` — the model path as called, without the host. */
export const AVM_MODELL_PFAD = /^\/models\/v4\/(ppch|opch)\/(a1|a2|a3|cv)$/;
export const avmDossierAntwortSchema = z
    .object({
    executionInfo: z
        .object({ id: text, start: text, end: text, version: text })
        .partial()
        .strict()
        .optional(),
    result: z
        .object({
        modelId: zahlOderText,
        modelDate: zahlOderText,
        value: z.number(),
        lowConfInt50: z.number(),
        hiConfInt50: z.number(),
        lowConfInt95: z.number(),
        hiConfInt95: z.number(),
        qualityCode: zahlOderText,
        qualityText: text,
        text,
    })
        .partial()
        .strict()
        .optional(),
    dataInfo: z
        .object({
        validationCode: text,
        validationText: text,
        replaceCode: text,
        replaceText: text,
        checkingCode: text,
        checkingText: text,
    })
        .partial()
        .strict()
        .optional(),
    parameterInfo: z
        .array(z
        .object({
        name: text,
        type: text,
        value: text,
        qualityCode: zahlOderText,
        qualityText: text,
    })
        .partial()
        .strict())
        .max(DOSSIER_PARAMETER_MAX)
        .optional(),
})
    .strict();
export const avmDossierSchema = z
    .object({
    modellPfad: z.string().regex(AVM_MODELL_PFAD),
    request: z
        .object({
        query: text,
        body: z.record(z.string(), z.unknown()),
        /**
         * Master 8-10: the body fields IN SEND ORDER — Postgres jsonb keeps no
         * key order, the annex and the export show what went to IAZI, in order.
         * Optional: dossiers stored before this field read from `body`.
         */
        felder: z
            .array(z
            .object({ name: text, value: z.union([z.number(), text, z.boolean(), z.null()]) })
            .strict())
            .max(DOSSIER_PARAMETER_MAX)
            .optional(),
    })
        .strict(),
    response: avmDossierAntwortSchema,
})
    .strict();
